"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const data_1 = require("../../../data");
const petitionPublish = (0, graphql_tag_1.default)`
  ${data_1.userMiniPopupSchemaFields}
  ${data_1.documentSchemaFields}
  mutation petitions_petition_publish($petitionId: Int!) {
    petitions {
      petition {
        publish(petitionId: $petitionId) {
          id
          title
          description
          status
          dateCreated
          dateFinish
          cover
          votedCount
          creator {
            ...userMiniPopupSchemaFields
          }
          attachments {
            ...documentSchemaFields
          }
        }
      }
    }
  }
`;
exports.default = petitionPublish;